import { useNavigate } from "react-router-dom";

import LandingIntroSection from "./LandingSections/LandingIntroSection";
import LandingStatsBar from "./LandingSections/LandingStatsBar";
import LandingRiskSection from "./LandingSections/LandingRiskSection";
import LandingAffectedSection from "./LandingSections/LandingAffectedSection";
import LandingThreeColumns from "./LandingSections/LandingThreeColumns";
import LandingProductShowcaseSection from "./LandingSections/LandingProductShowcaseSection";
import LandingComparisonSection from "./LandingSections/LandingComparisonSection";
import LandingHowItWorksSection from "./LandingSections/LandingHowItWorksSection";
import LandingExpertsSection from "./LandingSections/LandingExpertsSection";
import LandingSecuritySection from "./LandingSections/LandingSecuritySection";
import LandingLeadMagnetSection from "./LandingSections/LandingLeadMagnetSection";

export default function Home() {
	const navigate = useNavigate();

	const handleStart = (answer: "yes" | "no" | "unknown") => {
		navigate(`/questionnaire/${answer}`);
	};

	return (
		<div className="w-full flex flex-col items-center">
			<LandingIntroSection handleStart={handleStart} />
			<LandingStatsBar />
			<LandingRiskSection />
			<LandingAffectedSection />
			<LandingThreeColumns />
			<LandingProductShowcaseSection />
			<LandingComparisonSection />
			<LandingHowItWorksSection />
			<LandingExpertsSection />
			<LandingSecuritySection />
			<LandingLeadMagnetSection />
		</div>
	);
}
